import * as React from 'react';

const SvgScrollUp = (props) => (
  <svg
    width={16}
    height={16}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#scrollUp_svg__a)'>
      <path
        d='M2.909 8 6.727 4.18v11.031h2.546V4.182L13.091 8l1.697-1.697L8-.486 1.212 6.303 2.909 8Z'
        fill='#4D4D4D'
      />
    </g>
    <defs>
      <clipPath id='scrollUp_svg__a'>
        <path fill='#fff' transform='rotate(-90 8 8)' d='M0 0h16v16H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgScrollUp;
